import Vue from "vue"
import router from "@/router/index.js"
// import VueAxios from "vue-axios"
// import axios from "axios"

const ApiService = {
  init() {
    Vue.axios.defaults.headers = {
      Accept: "application/json",
    }
    Vue.axios.defaults.withCredentials = true
    this.setInterceptor()
  },

  setInterceptor() {
    let isRedirecting = false

    Vue.axios.interceptors.response.use(
      (response) => {
        //

        return response
      },
      (error) => {
        if (!error.response) {
          throw error
        }

        if (
          !(
            Object.prototype.hasOwnProperty.call(error.config, "errorHandle") &&
            error.config.errorHandle === false
          )
        ) {
          if (error.response.status === 401 && !isRedirecting) {
            isRedirecting = true

            /** When authentication cookie is no longer valid,
             * we need to remove multi-tab-state key/value from local storage.
             */

            let uri = window.location.pathname

            if (uri !== "/login") window.location.href = "/login?link=" + uri
          }

          if (error.response.status === 403) {
            // EventSys.$emit("error404", { message: "page_not_found" })
            router.push({ name: "notFound" }).then((r) => r)
            return
          }

          if (error.response.status === 404) {
            // eslint-disable-next-line no-undef
            EventSys.$emit("error404", { message: "page_not_found" })

            throw error
          }
        }

        if (error.response.status === 409) {
          // eslint-disable-next-line no-undef
          EventSys.$emit("error409", { message: error.response.data.message })
          throw error
        }

        if (error.response.status === 500) {
          // eslint-disable-next-line no-undef
          EventSys.$emit("server_error")
          throw error
        }

        // if (error.response.status === 429 && !isRedirecting) {
        //   isRedirecting = true

        //   window.location.href = "/too-many-requests"

        //   throw error
        // }

        throw error
      }
    )
  },

  get(slug, $meta = {}) {
    return Vue.axios.get(slug, $meta)
  },

  post(slug, data, $options = {}) {
    return Vue.axios.post(slug, data, $options)
  },

  put(slug, data, $options = {}) {
    return Vue.axios.put(slug, data, $options)
  },

  delete(slug, $options = {}) {
    return Vue.axios.delete(slug, $options)
  },
}

export default ApiService
